(function () {
    'use strict';

    angular
    .module('app')
    .controller('RecycleBinController', RecycleBinController);

    RecycleBinController.$inject = ['API', 'alert', 'debug', 'helpers', '$stateParams', 'ListViewSearchExtension', 'i18n',];

    function RecycleBinController(API, alert, debug, helpers, $stateParams, ListViewSearchExtension, i18n) {
        var vm = this;

        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            'sort': 'createdAscending'
        };
        vm.listObject.perPage = 20;
        vm.loadingState = {
            items: false,
        };

        vm.loadResources = loadResources;
        vm.restore = restore;
        vm.deletePermanently = deletePermanently;
        vm.seeContents = seeContents;
        vm.keyUp = keyUp;
        vm.items = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }

            loadResources(true);
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'expand': 'user',
            };
            if (vm.listObject.filter) {
                switch (vm.listObject.filter.sort) {
                    case 'createdAscending':
                    searchObject.sort = '-created_at';
                    break;
                    case 'createdDescending':
                    searchObject.sort = 'created_at';
                    break;

                    default:
                    break;
                }
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.RecycleBin.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.RecycleBin.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.items = true;
                promise.then(function (response) {
                    vm.items = [];
                    angular.forEach(response.items, function(item) {
                        item.data = JSON.parse(item.data);
                        // We assume the object that was moved to the recycle bin is the first in the array since that is how it is sorted in the backend.
                        var data = Object.values(item.data)[0];
                        var type = Object.keys(item.data)[0];

                        // Request to name group as "class" or "family"
                        item.humanIdentifier = type === 'group' ? data.type + ': ' : helpers.idToLabel(type) + ': ';
                        if (data.name) {
                            item.humanIdentifier += data.name + ' ';
                        }
                        if (type === 'user') {
                            if (data.user_type) {
                                item.humanIdentifier += data.user_type + ' ';
                            }
                            if (data.first_name) {
                                item.humanIdentifier += data.first_name + ' ';
                            }
                            if (data.last_name) {
                                item.humanIdentifier += data.last_name + ' ';
                            }
                            if (!data.first_name && !data.last_name) {
                                if (data.user_type === 'parent' || data.user_type === 'teacher') {
                                    item.humanIdentifier += item.data.login_teacher[0].email + ' ';
                                }
                                if (data.user_type === 'child' || data.user_type === 'student') {
                                    item.humanIdentifier += item.data.login_student[0].username + ' ';
                                }
                            }
                        }
                        vm.items.push(item);
                    });
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.items = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }

        function restore(item) {
            var promise = alert.confirm('restore-from-recycle-bin');

            promise.then(function() {
                var restorePromise = API.RecycleBin.restore({}, { id: item.id }).$promise;
                restorePromise.then(function() {
                    var index = vm.items.findIndex(function(i) {
                        return i.id === item.id;
                    });
                    vm.items.splice(index, 1);
                    window.toast({ message: i18n.get('OBJECT_RESTORED_FROM_RECYCLE_BIN'), type: 'success' });
                }, function() {});
            }, function() {});
        }

        function seeContents(item) {
            alert.open('print-object', { object: helpers.printObject(item.data) });
        }

        function deletePermanently(item) {
            var promise = alert.confirm('delete-from-recycle-bin');

            promise.then(function() {
                var deletePromise = API.RecycleBin.delete({}, { id: item.id }).$promise;

                deletePromise.then(function() {
                    var index = vm.items.findIndex(function(i) {
                        return i.id === item.id;
                    });
                    vm.items.splice(index, 1);
                    window.toast({ message: i18n.get('OBJECT_DELETED_PERMANENTLY'), type: 'success' });
                });

            }, function() {});
        }

    }
})();